import type { FormStep } from "./StepTabs";

/** The next open step in a direction, or null when there is none: Continue and
 * Back skip the steps a switch has closed. */
export function nextOpenStep<K extends string>(
  steps: FormStep<K>[],
  current: K,
  direction: 1 | -1,
): K | null {
  const index = steps.findIndex((step) => step.key === current);
  for (let i = index + direction; i >= 0 && i < steps.length; i += direction) {
    if (!steps[i].disabled) return steps[i].key;
  }
  return null;
}
